module.exports = __webpack_public_path__ + "img/logo_88.7aff36b5.png";